import { Footer } from '@soteria/design-system-ve';
import { Link } from 'react-router-dom';

export function PageFooter() {
  return (
    <Footer
      absolute
      transparent
      infoLink={{
        href: 'https://support.microsoft.com/en-us/account-billing/avoid-staying-signed-in-on-a-public-computer-d3f1448b-64b9-4b35-89d0-ce56715c6756',
        label: 'Learn more',
      }}
      infoText="Use private browsing if this is not your device."
      links={[
        { href: 'https://www.microsoft.com/en-us/servicesagreement/', label: 'Terms of use' },
        { href: 'https://www.microsoft.com/en-us/privacy/privacystatement', label: 'Privacy and cookies' },
      ]}
      logo={<img alt="Xbox" height={28} src="https://logincdn.msftauth.net/shared/5/images/xbox_logo_white_cde084563e169a9848af.svg" width={90} />}
      renderLink={(link, className) => (
        <Link className={className} to={link.href}>
          {link.label}
        </Link>
      )}
    />
  );
}
